import React from "react";
import { NoDataComponent } from "../no-data.component.tsx";
import { PartListFactory } from "./PartListFactory";
import { PartsListContent, PartsListItems } from "./parts-list-content.component.tsx";

export class PartListFactoryImpl implements PartListFactory {
    create(partListItems: PartsListItems[]): React.ReactElement<any, string | React.JSXElementConstructor<any>> {
        if (!partListItems) return <NoDataComponent />
        return <PartsListContent products={partListItems} />
    }
}